import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom'
import { UserProfile } from '../../Dashboard/components/UserProfile'

const Profile = () =>{
    const parmas = useParams()
    const [selectedUserData, setSelectedUserData]=React.useState({})
    useEffect(()=>{
        console.log(parmas);
    }, [parmas])
    return <>
        { parmas.id && <UserProfile
            selectedUser={parmas.id}
            setSelectedUserData={setSelectedUserData} /> }
    </>
}

export default Profile;